module.exports = __webpack_public_path__ + "static/media/more.76347d0a.svg";